import { logger } from '../utils/logger';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from '../app/store';
import {
    isLoading,
    loadDataHabilitacion,
    loadListHabilitacion,
    resetHabilitacion as resetHabilitacionAction,
    habilitacionInitial,
} from '../context/HabilitacionContratista/HabilitacionContratistaReducer';
import { HabilitacionContratista } from '../types/HabilitacionContratista';
import { findAll, get, save, update, cargarCombo } from '../services/Service';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';

export const useHabilitacionContratista = () => {
    const BASE_URL = 'habilitacion-contratista';
    const navigate = useNavigate();

    const { habilitaciones, habilitacionSelected, loading } = useSelector(
        (state: RootState) => state.habilitacionContratista
    );
    const { usuarioLogin } = useSelector((state: RootState) => state.auth);
    const dispatch = useDispatch();

    const buscarHabilitacion = async (id: string) => {
        await get(BASE_URL, id)
            .then((response) => {
                dispatch(loadDataHabilitacion(response.data));
            })
            .catch((error) => {
                logger.log(error);
            });
    };

    const buscarHabilitaciones = async () => {
        const params: Record<string, any> = {};
        if (usuarioLogin?.idContratista) {
            params.idContratista = usuarioLogin.idContratista;
        }
        await findAll(BASE_URL, params)
            .then((response) => {
                dispatch(loadListHabilitacion(response.data));
            })
            .catch((error) => {
                logger.log(error);
            });
    };

    const crearHabilitacion = async (habilitacion: any) => {
        try {
            const result = await save(BASE_URL, habilitacion);
            dispatch(loadDataHabilitacion(result.data));
            navigate(`/habilitacion-contratista/${result.data.id}`);
        } catch (error) {
            logger.log(error);
            throw error;
        }
    };

    const updateHabilitacion = async (habilitacion: any) => {
        try {
            const response = await update(BASE_URL, habilitacion);
            dispatch(loadDataHabilitacion(response.data));
            return response;
        } catch (error) {
            logger.error(error);
            throw error;
        }
    };

    const validateHabilitacion = async (idHabilitacion: number) => {
        const response = await get(`${BASE_URL}/validate`, idHabilitacion.toString());
        return response.data; // { valid: boolean, errores: string[] }
    };

    const validarCalificarHabilitacion = async (idHabilitacion: number) => {
        try {
            const response = await get(
                `${BASE_URL}/validar-calificar`,
                idHabilitacion.toString()
            );
            return response.data; // false = no hay documentos sin revisar
        } catch (error: any) {
            if (error.response) {
                toast.error(error.response.data.message);
            } else {
                toast.error('Error al validar la habilitación');
            }
            logger.error(error);
        }
    };

    const sendHabilitacion = async (idHabilitacion: number) => {
        try {
            const response = await get(`${BASE_URL}/send`, idHabilitacion.toString());
            dispatch(loadDataHabilitacion(response.data));
            return response.data;
        } catch (error: any) {
            if (error.response) {
                toast.error(error.response.data.message);
            }
            logger.error(error);
        }
    };

    const resetHabilitacion = () => {
        dispatch(resetHabilitacionAction());
    };

    const handleHabilitacionSelected = (habilitacion: HabilitacionContratista) => {
        dispatch(loadDataHabilitacion(habilitacion));
    };

    const handleLoading = (load: boolean) => {
        dispatch(isLoading(load));
    };

    return {
        habilitaciones,
        habilitacionSelected,
        loading,
        habilitacionInitial,
        buscarHabilitacion,
        buscarHabilitaciones,
        crearHabilitacion,
        updateHabilitacion,
        validateHabilitacion,
        validarCalificarHabilitacion,
        sendHabilitacion,
        resetHabilitacion,
        handleHabilitacionSelected,
        handleLoading,
        cargarCombo,
    };
};
